<script>
  let { size = 5, title = 'Todo', class: className } = $props();
</script>

<svg
  width={size * 4}
  height={size * 4}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={className}
>
  {#if title}<title>{title}</title>{/if}
  <path
    class="animate-indicator-first"
    fill="#FECDD3"
    d="M4.7501 5.59141C4.4251 5.91641 4.4251 6.44141 4.7501 6.76641L7.98343 9.99974L4.7501 13.2331C4.4251 13.5581 4.4251 14.0831 4.7501 14.4081C5.0751 14.7331 5.6001 14.7331 5.9251 14.4081L9.7501 10.5831C10.0751 10.2581 10.0751 9.73307 9.7501 9.40807L5.93343 5.59141C5.60843 5.26641 5.0751 5.26641 4.7501 5.59141Z"
  />
  <path
    class="animate-indicator-second"
    fill="#FECDD3"
    d="M10.2416 5.59148C9.91655 5.91648 9.91655 6.44148 10.2416 6.76648L13.4749 9.99981L10.2416 13.2331C9.91655 13.5581 9.91655 14.0831 10.2416 14.4081C10.5666 14.7331 11.0916 14.7331 11.4166 14.4081L15.2416 10.5831C15.5666 10.2581 15.5666 9.73315 15.2416 9.40815L11.4166 5.58315C11.0999 5.26648 10.5666 5.26648 10.2416 5.59148Z"
  />
</svg>
